module.exports = __webpack_public_path__ + "img/gallery.291f70a3.png";